import {
	ChangeDetectionStrategy,
	Component,
	OnChanges,
	OnInit,
	SimpleChanges,
	output,
	input,
} from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
	TimeSeriesSettings,
	TimeSeriesWithoutPagination,
} from '@app/pages/cmms/components/assets/asset-time-series/misc/interfaces';
import { NgxTolgeeModule } from '@tolgee/ngx';

type AssetChartSettingsFormData = TimeSeriesSettings & { description?: string };
type AssetChartSettingsFormGroup = {
	[K in keyof AssetChartSettingsFormData]: FormControl<AssetChartSettingsFormData[K]>;
};

@Component({
	selector: 'asset-chart-settings',
	templateUrl: './asset-chart-settings.component.html',
	styleUrls: ['./asset-chart-settings.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatError,
		MatLabel,
		MatTooltipModule,
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		NgxTolgeeModule,
	],
})
export class AssetChartSettingsComponent implements OnInit, OnChanges {
	settings = input<Pick<TimeSeriesWithoutPagination, 'settings' | 'description'>>();
	settingsChanged =
		output<Pick<TimeSeriesWithoutPagination, 'settings' | 'description'>>();

	settingsForm = new FormGroup<AssetChartSettingsFormGroup>(
		{
			lowerBound: new FormControl<number>(null),
			upperBound: new FormControl<number>(null),
			benchmark: new FormControl<number>(null),
			unit: new FormControl<string>(null, { validators: [Validators.maxLength(50)] }),
			description: new FormControl<string>(null, {
				validators: [Validators.maxLength(250)],
			}),
		},
		{ updateOn: 'blur' }
	);

	ngOnInit(): void {
		this.settingsForm.valueChanges.subscribe(value => {
			const { description, ...settings } = value;
			const settingsTypedValue = { settings, description };
			this.settingsChanged.emit(settingsTypedValue);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		const { description, settings } = changes.settings.currentValue;
		const settingsFormValue = { ...settings, description };
		this.settingsForm.patchValue(settingsFormValue, { emitEvent: false });
	}
}
